module.exports = __webpack_public_path__ + "img/revolucionCanina.b4d69457.jpg";